import { mapState, mapMutations, createNamespacedHelpers } from "vuex";
import { countDown, conversion } from "@/tool";
import { format_date } from "@/filters/format_date";
import { format_case_name } from "@/filters/format_case_name";

import CustomButton from "@/partials/custom_button";
import { CustomBlockTitle } from "@/partials/custom_block_title";
import Button from "@/components/button";
import Picture from "@/components/picture";
import BlockPanel from "@/components/block_panel";
import Award from "@/components/award";
import LiveDropBox from "@/partials/live_drop_box";
import NoticeBoard from "@/components/noticeboard/index.vue";
import Number from "@/components/AnimateNumber/index.vue";
import {
  GetItemDuration,
  GetItemName,
  GetItemSkinName,
  timeToCounter,
} from "@/tool";

import { roll_list } from "@/api";

const { mapActions: RollRoomsMapActions, mapGetters: RollRoomsMapGetters } =
  createNamespacedHelpers("roll_rooms");

export default {
  components: {
    "p-custom-button": CustomButton,
    "p-custom-block-title": CustomBlockTitle,
    "p-live-drop-box": LiveDropBox,
    "c-button": Button,
    "c-picture": Picture,
    "c-block-panel": BlockPanel,
    "c-award": Award,
    "c-notice-board": NoticeBoard,
    "c-number": Number,
  },

  filters: {
    conversion,
    countDown,
    format_date,
    format_case_name,
    GetItemDuration,
    GetItemName,
    GetItemSkinName,
    timeToCounter,
  },

  data() {
    return {
      Alert: false,
      active_cate_index: 0,
      price_range_index: 0,
      price_range: [
        { min: 0, max: 99999999 },
        { min: 0, max: 1 },
        { min: 2, max: 19 },
        { min: 20, max: 49 },
        { min: 50, max: 99 },
        { min: 100, max: 999999 },
      ],
      /** 注销首页Roll房刷新 */
      roll_room_list: [],
    };
  },

  computed: {
    ...RollRoomsMapGetters(["home_roll_rooms"]),

    ...mapState([
      "config",
      "boxList",
      "banner_list",
      "user",
      "notice_list",
      "GobalInfo",
    ]),

    /** 推荐宝箱 */
    // cateCaseList() {
    //   return (cate) => {
    //     return this.boxList?.list?.filter((_) => _.catagory == cate);
    //   };
    // },
    cateCaseList() {
      return (cate) => {
        return this.boxList.list.filter(_ => _.catagory == cate
          && _.price >= this.price_range[this.price_range_index].min
          && _.price <= this.price_range[this.price_range_index].max)
      };
    },
    cateCaseCategory() {
      return this.boxList?.category?.filter((item) =>
        [ "五五箱"].includes(item)
      );
    },
  },

  async mounted() {
    if (this.$route.params.scrollIntoView) {
      document
        .getElementById(this.$route.params.scrollIntoView)
        .scrollIntoView({ block: "center" });
    }

  },
  //离开当前组件前一定要清除滚动监听，否则进入其他路由会报错
  beforeRouteLeave(to, from, next) {
    next();
  },
  async created() {
    // 获取首页箱子列表
    this.getboxList();

    // 刷新Roll房信息
    this.getRollRoomList();
  },

  async beforeDestroy() {},

  methods: {
    ...RollRoomsMapActions(["refresh_home_roll_rooms"]),

    ...mapMutations(["getboxList"]),
    getRollRoomList() {
      roll_list({ type: 0, size: 3, page: 1 }).then((res) => {
        if (res.data.code === 0) {
          this.roll_room_list = res.data.data;
        }
      });
    },

    heightToTop(ele) {
      //ele为指定跳转到该位置的DOM节点
      let root = document.body;
      let height = -180;

      do {
        height += ele.offsetTop;
        ele = ele.offsetParent;
      } while (ele !== root);
      return height;
    },
    //某按钮点击时
    toCaseCate(index) {
      this.active_cate_index = index;
      window.scrollTo({
        top: this.heightToTop(this.$refs["caseloc" + index][0]),
        behavior: "smooth",
      });
    },
    //关闭广告
    AlertClose() {
      this.$cookies.set("Alert", this.announcementText, "7d");
      this.Alert = false;
    },

    pathGo(obj) {
      if (obj.name === "exclusiveDetail") {
        return this.$router.push({
          name: "exclusiveDetail",
          params: { id: obj.id, },
          query:{name:obj.category}
        });
      }

      this.$router.push(obj);
    },

    /** swiper 自动播放切换 */
    async on_swiper_autoplay_toggle(swiper, event) {
      if (!swiper) return null;

      event.type === "mouseleave" && swiper.autoplay.start();

      event.type === "mouseenter" && swiper.autoplay.stop();
    },
  },
};
